import store from '@/store/store'
import { setCustomTextModal } from './action'
import { setModalCallbacks } from './callbackRegistry'

export function setShowModalCustomText(
  header: string,
  text: string,
  primaryButtonText: string = null,
  secondaryButtonText: string = null,
  showSecondaryButton: boolean = false,
  onPrimaryClick?: () => void,
  onSecondaryClick?: () => void,
  primaryButtonVariant?: 'default' | 'gradient' | 'super-gradient'
) {
  const callbackGeneration = setModalCallbacks({ onPrimary: onPrimaryClick, onSecondary: onSecondaryClick })
  store.dispatch(setCustomTextModal({ header, text, primaryButtonText, secondaryButtonText, showSecondaryButton, callbackGeneration, primaryButtonVariant }))
}
